import { conciergeClient, ConciergeSuccessResponse } from 'src/api/concierge';
import { InspectionAction } from 'src/features/building/components/enum/inspection-action';
import { CleanType } from 'src/features/building/components/enum/clean-type';
import { HousekeepingInspection } from 'src/features/building/api/types';

import { BookingsEndpoints } from './constants';

import type {
    GetBookingsParams,
    GetBookingsSuccessResponse,
    GetBookingsSummarySuccessResponse,
    PatchBookingBody,
    PatchBookingSuccessResponse,
} from './types';

export const getBookingsList = async (params?: GetBookingsParams) => {
    const { data: response } = await conciergeClient.get<GetBookingsSuccessResponse>(
        BookingsEndpoints.getMyBookings,
        {
            params,
        }
    );

    return response.data;
};

export const patchBooking = async (id: string, payload: PatchBookingBody) => {
    const { data: response } = await conciergeClient.patch<PatchBookingSuccessResponse>(
        BookingsEndpoints.patchMyBookings.replace('{id}', id),
        payload
    );

    return response.data;
};

export const getBookingsSummary = async () => {
    const { data: response } = await conciergeClient.get<GetBookingsSummarySuccessResponse>(
        BookingsEndpoints.getBookingsSummary
    );

    return response.data;
};

export const postInspectionAction = async (
    inspectionId: string,
    academicYear: string,
    action: InspectionAction
) => {
    await conciergeClient.post(
        BookingsEndpoints.postInspectionAction.replace(':inspectionId', inspectionId),
        {
            action,
        },
        {
            params: {
                academic_year: academicYear,
            },
        }
    );
};

export const patchInspection = async (
    inspectionId: string,
    academicYear: string,
    preferredCleaningTime?: string,
    cleanType?: CleanType
) => {
    await conciergeClient.patch(
        BookingsEndpoints.patchInspection.replace(':inspectionId', inspectionId),
        {
            ...(preferredCleaningTime && { preferredCleaningTime }),
            ...(cleanType && { cleanType }),
        },
        {
            params: {
                academic_year: academicYear,
            },
        }
    );
};

export const getInspections = async (academic_year: string) => {
    const { data: response } = await conciergeClient.get<
        ConciergeSuccessResponse<HousekeepingInspection | null>
    >(BookingsEndpoints.getInspections, {
        params: {
            academic_year,
        },
    });

    return response.data;
};

export const getVoucherCode = async () => {
    const { data: response } = await conciergeClient.get<ConciergeSuccessResponse<string | null>>(
        BookingsEndpoints.getVoucherCode
    );

    return response.data;
};
